import { render, staticRenderFns } from "./YzDataTable.vue?vue&type=template&id=6505b660&scoped=true&lang=pug&"
import script from "./YzDataTable.vue?vue&type=script&lang=js&"
export * from "./YzDataTable.vue?vue&type=script&lang=js&"
import style0 from "./YzDataTable.vue?vue&type=style&index=0&id=6505b660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6505b660",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
